import { isSSR } from '@repo/ui/src/utils/isSSR';
import React from 'react';

export const useScrollLock = () => {
  const [isLocked, setIsLocked] = React.useState(
    () => !isSSR && window.document.body.classList.contains('overflow-hidden'),
  );
  const lock = React.useCallback(() => {
    setIsLocked(true);
  }, []);
  const unlock = React.useCallback(() => {
    setIsLocked(false);
  }, []);

  React.useEffect(() => {
    if (isLocked) {
      window.document.body.classList.add('overflow-hidden');
    } else {
      window.document.body.classList.remove('overflow-hidden');
    }
    return () => window.document.body.classList.remove('overflow-hidden');
  }, [isLocked]);

  return {
    isLocked,
    setIsLocked,
    lock,
    unlock,
  };
};
